import logo from "assets/logo.svg";
import logoLight from "assets/logo-light.svg";
import { Link } from "react-router-dom";
import { _links } from "utils/helper/links";
import NewsLetterSub from "./newsletter.component";
import { FaApple } from "react-icons/fa6";
import { classNames } from "utils/helper/helper";
import PlayStoreSvg from "components/toolkit/playstore.svg";
import { IoMdMail } from "react-icons/io";

function Footer() {
  return (
    <footer className="bg-[#5A5A5A] dark:bg-[#E5571A]">
      <div className="mx-auto w-full max-w-screen-xl p-4 pt-12 pb-6 lg:pt-20">
        <div className="md:flex md:justify-between">
          <div className="mb-6 md:mb-0">
            <Link
              to="/"
              className="mb-6 flex items-center">
              <img
                src={logo}
                className="h-8 me-3 dark:hidden"
                alt="Vhicasar Homes Logo"
              />
              <img
                src={logoLight}
                className="h-8 me-3 hidden dark:block"
                alt="Vhicasar Homes Logo"
              />
            </Link>
            <p className="text-[#F7F8FA] mb-12 text-sm">
              Transforming Chores into Choice
            </p>
            
            <p className="text-[#F7F8FA] mb-5 text-sm">
              Contact Support:
            </p>
            <p className="text-[#F7F8FA] mb-2 text-sm">
              +2349062145754
            </p>
            <p className="text-[#F7F8FA] mb-12 text-sm">
              support@vhicasar.com
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:gap-24 sm:grid-cols-2">
            <div>
              <h2 className="mb-6 text-sm font-semibold text-white uppercase dark:text-white">
                Quick links
              </h2>
              <ul className="text-[#F7F8FA] font-medium">
                <li className="mb-4">
                  <Link
                    to={_links.services}
                    className="hover:underline">
                    Services
                  </Link>
                </li>
                <li>
                  <Link
                    to={_links.faq}
                    className="hover:underline">
                    FAQs
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold text-white uppercase dark:text-white">
                Company
              </h2>
              <ul className="text-[#F7F8FA] font-medium">
                <li className="mb-4">
                  <Link
                    to={_links.about}
                    className="hover:underline ">
                    About Us
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to={_links.contact_us}
                    className="hover:underline">
                    Contact
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to={_links.privacy}
                    className="hover:underline">
                    Privacy Policy
                  </Link>
                </li>
                <li className="mb-4">
                  <Link
                    to={_links.refund}
                    className="hover:underline">
                    Refund Policy
                  </Link>
                </li>
                <li>
                  <Link
                    to={_links.terms}
                    className="hover:underline">
                    Terms and Conditions
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="md:flex md:justify-between mt-6 text-[#F7F8FA]">
          <div className="mb-6 md:mb-0 space-y-3">
            <p className="text-[#F7F8FA]">Subscribe to our newsletter</p>
            <NewsLetterSub />
            <div className="flex items-center gap-2">
              <a
                href="http://"
                target="_blank"
                rel="noopener noreferrer"
                className={classNames(
                  "bg-[#1A1A1A] flex gap-2 items-center",
                  "rounded-lg py-2.5 px-6"
                )}>
                <FaApple size={24} />
                <span className="text-center flex flex-col text-sm">
                  <span>Download on the</span>
                  <span>App Store</span>
                </span>
              </a>
              <a
                href="http://"
                target="_blank"
                rel="noopener noreferrer"
                className={classNames(
                  "bg-[#1A1A1A] flex gap-2 items-center",
                  "rounded-lg py-2.5 px-6"
                )}>
                <PlayStoreSvg />
                <span className="text-center flex flex-col text-sm">
                  <span>Android app on</span>
                  <span>Google Play</span>
                </span>
              </a>
            </div>
          </div>
          <div className="mb-6 md:mb-0 space-y-3">
            <p className="text-[#F7F8FA]">Contact Us</p>
            <a
              href="mailto:"
              className="flex items-center gap-2">
              <IoMdMail size={48} />
              <span>Send us a mail</span>
            </a>
          </div>
        </div>

        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm text-[#F7F8FA] sm:text-center">
            © 2024{" "}
            <a
              href="/"
              className="hover:underline">
              Vhicasar Homes
            </a>
            . All Rights Reserved.
          </span>
          <div className="flex mt-4 sm:justify-center sm:mt-0">
            <a
              href="#!"
              className="text-[#F7F8FA] hover:text-white dark:hover:text-white">
              <svg
                className="w-6 h-6"
                width={40}
                height={40}
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.7134 3.33506C22.9296 3.33039 24.1458 3.34261 25.3617 3.37173L25.685 3.38339C26.0584 3.39673 26.4267 3.41339 26.8717 3.43339C28.645 3.51673 29.855 3.79673 30.9167 4.20839C32.0167 4.63173 32.9434 5.20506 33.87 6.13173C34.7173 6.9644 35.3731 7.97164 35.7917 9.08339C36.2034 10.1451 36.4834 11.3567 36.5667 13.1301C36.5867 13.5734 36.6034 13.9434 36.6167 14.3167L36.6267 14.6401C36.6563 15.8554 36.6691 17.0711 36.665 18.2867L36.6667 19.5301V21.7134C36.6708 22.9296 36.658 24.1459 36.6284 25.3617L36.6184 25.6851C36.605 26.0584 36.5884 26.4267 36.5684 26.8717C36.485 28.6451 36.2017 29.8551 35.7917 30.9167C35.3744 32.0297 34.7185 33.0377 33.87 33.8701C33.0366 34.7173 32.0289 35.373 30.9167 35.7917C29.855 36.2034 28.645 36.4834 26.8717 36.5667C26.4267 36.5867 26.0584 36.6034 25.685 36.6167L25.3617 36.6267C24.1458 36.6564 22.9296 36.6691 21.7134 36.6651L20.47 36.6667H18.2884C17.0721 36.6708 15.8559 36.6581 14.64 36.6284L14.3167 36.6184C13.921 36.6041 13.5255 36.5874 13.13 36.5684C11.3567 36.4851 10.1467 36.2017 9.08336 35.7917C7.97117 35.374 6.96376 34.7181 6.13169 33.8701C5.28343 33.0372 4.62707 32.0293 4.20836 30.9167C3.79669 29.8551 3.51669 28.6451 3.43336 26.8717C3.4148 26.4763 3.39813 26.0807 3.38336 25.6851L3.37503 25.3617C3.3443 24.1459 3.33041 22.9296 3.33336 21.7134V18.2867C3.32871 17.0711 3.34093 15.8554 3.37003 14.6401L3.38169 14.3167C3.39503 13.9434 3.41169 13.5734 3.43169 13.1301C3.51503 11.3551 3.79503 10.1467 4.20669 9.08339C4.62565 7.97109 5.2833 6.96413 6.13336 6.13339C6.96485 5.28465 7.97163 4.62768 9.08336 4.20839C10.1467 3.79673 11.355 3.51673 13.13 3.43339L14.3167 3.38339L14.64 3.37506C15.8553 3.34435 17.071 3.33046 18.2867 3.33339L21.7134 3.33506ZM20 11.6684C18.8959 11.6528 17.7996 11.8568 16.775 12.2685C15.7504 12.6802 14.8178 13.2915 14.0314 14.0668C13.2451 14.8421 12.6207 15.766 12.1945 16.7847C11.7683 17.8034 11.5488 18.8966 11.5488 20.0009C11.5488 21.1052 11.7683 22.1984 12.1945 23.2171C12.6207 24.2358 13.2451 25.1597 14.0314 25.935C14.8178 26.7103 15.7504 27.3215 16.775 27.7333C17.7996 28.145 18.8959 28.349 20 28.3334C22.2102 28.3334 24.3298 27.4554 25.8926 25.8926C27.4554 24.3298 28.3334 22.2102 28.3334 20.0001C28.3334 17.7899 27.4554 15.6703 25.8926 14.1075C24.3298 12.5447 22.2102 11.6684 20 11.6684ZM20 15.0017C20.6642 14.9895 21.3242 15.1097 21.9414 15.3554C22.5585 15.6011 23.1206 15.9673 23.5947 16.4326C24.0687 16.898 24.4453 17.4531 24.7024 18.0656C24.9595 18.6781 25.092 19.3358 25.0921 20C25.0922 20.6643 24.96 21.322 24.7031 21.9346C24.4462 22.5472 24.0698 23.1025 23.5958 23.568C23.1219 24.0335 22.56 24.3998 21.9429 24.6457C21.3258 24.8916 20.6659 25.0121 20.0017 25.0001C18.6756 25.0001 17.4038 24.4733 16.4662 23.5356C15.5285 22.5979 15.0017 21.3261 15.0017 20.0001C15.0017 18.674 15.5285 17.4022 16.4662 16.4645C17.4038 15.5268 18.6756 15.0001 20.0017 15.0001L20 15.0017ZM28.75 9.16839C28.2123 9.18991 27.7038 9.41864 27.331 9.80668C26.9582 10.1947 26.75 10.7119 26.75 11.2501C26.75 11.7882 26.9582 12.3054 27.331 12.6934C27.7038 13.0815 28.2123 13.3102 28.75 13.3317C29.3026 13.3317 29.8325 13.1122 30.2232 12.7215C30.6139 12.3308 30.8334 11.8009 30.8334 11.2484C30.8334 10.6959 30.6139 10.166 30.2232 9.77525C29.8325 9.38455 29.3026 9.16506 28.75 9.16506V9.16839Z"
                  fill="white"
                />
              </svg>

              <span className="sr-only">Instagram page</span>
            </a>
            <a
              href="#!"
              className="text-[#F7F8FA] hover:text-white dark:hover:text-white ms-5">
              <svg
                className="w-6 h-6"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M37.4333 9.99984C36.15 10.5832 34.7666 10.9665 33.3333 11.1498C34.8 10.2665 35.9333 8.8665 36.4666 7.18317C35.0833 8.0165 33.55 8.59984 31.9333 8.93317C30.6166 7.49984 28.7666 6.6665 26.6666 6.6665C22.75 6.6665 19.55 9.8665 19.55 13.8165C19.55 14.3832 19.6166 14.9332 19.7333 15.4498C13.8 15.1498 8.51665 12.2998 4.99998 7.98317C4.38332 9.03317 4.03332 10.2665 4.03332 11.5665C4.03332 14.0498 5.28332 16.2498 7.21665 17.4998C6.03332 17.4998 4.93332 17.1665 3.96665 16.6665V16.7165C3.96665 20.1832 6.43332 23.0832 9.69998 23.7332C8.6512 24.0202 7.55014 24.0601 6.48332 23.8498C6.93599 25.2706 7.82254 26.5139 9.01834 27.4047C10.2141 28.2956 11.6591 28.7893 13.15 28.8165C10.6227 30.8172 7.48998 31.8987 4.26665 31.8832C3.69998 31.8832 3.13332 31.8498 2.56665 31.7832C5.73332 33.8165 9.49998 34.9998 13.5333 34.9998C26.6666 34.9998 33.8833 24.0998 33.8833 14.6498C33.8833 14.3332 33.8833 14.0332 33.8666 13.7165C35.2666 12.7165 36.4666 11.4498 37.4333 9.99984Z"
                  fill="white"
                />
              </svg>

              <span className="sr-only">Twitter Page</span>
            </a>
            <a
              href="#!"
              className="text-[#F7F8FA] hover:text-white dark:hover:text-white ms-5">
              <svg
                className="w-6 h-6"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.6667 20.0002C36.6667 10.8002 29.2 3.3335 20 3.3335C10.8 3.3335 3.33337 10.8002 3.33337 20.0002C3.33337 28.0668 9.06671 34.7835 16.6667 36.3335V25.0002H13.3334V20.0002H16.6667V15.8335C16.6667 12.6168 19.2834 10.0002 22.5 10.0002H26.6667V15.0002H23.3334C22.4167 15.0002 21.6667 15.7502 21.6667 16.6668V20.0002H26.6667V25.0002H21.6667V36.5835C30.0834 35.7502 36.6667 28.6502 36.6667 20.0002Z"
                  fill="white"
                />
              </svg>
              <span className="sr-only">facebook page</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
